<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData= $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:cancel="cancelHandler"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";


import DomesticInquiryForm from "../../../components/industrialrelations/domesticinquiry/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": DomesticInquiryForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      search: this.$route.params.search,
      pageTitle:this.$t('ircasemaintenance.dimaintenanceedit'),
      pageTitleValue: "",
      formData: {
        id: this.$route.params.id,
        ircaseid: null,
        incidentdate: null,
        shortdesc: null,
        longdesc: null,
        staffid: null,
        sessiondesc: null,
        ditime: null,
        didate: null,
        venueid: null,
        panelmemberdetail: [],
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      errMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {

    errorHandler($event) {
    this.isErr = $event.isErr;
    this.errMsg = $event.errMsg;
    },

    loadDomesticInquiryHandler() {
      const vm = this;

      return this.$store.dispatch('get', {url: "/irdomesticinquiry/" + vm.id})
        .then((res) => {
          
          if (res.data.rec[0].didate) {
              vm.formData.didate = moment(res.data.rec[0].didate).format(
              "YYYY-MM-DD"
            );
          }

          if (res.data.rec[0].incidentdate) {
              vm.formData.incidentdate = moment(res.data.rec[0].incidentdate).format(
              "YYYY-MM-DD"
            );
          }

          vm.formData.ircaseid = res.data.rec[0].ircaseid;
          vm.formData.shortdesc = res.data.rec[0].shortdesc;
          vm.formData.staffid = res.data.rec[0].staffid;

          vm.formData.sessiondesc= res.data.rec[0].sessiondesc;
         // vm.formData.didate = res.data.rec[0].didate;
          vm.formData.ditime = res.data.rec[0].ditime;
          vm.formData.venueid= res.data.rec[0].venueid;
          vm.formData.irdomesticvenuecode= res.data.rec[0].irdomesticvenuecode;
          vm.formData.irdomesticvenuedesc= res.data.rec[0].irdomesticvenuedesc;

          vm.formData.stamp = res.data.rec[0].stamp;
          vm.formData.userid = this.$store.getters.userId;
          
          vm.pageTitleValue = res.data.rec[0].policyno;

          this.loadCoverageTypeHandler();
         // vm.loading = false;

        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    
    loadCoverageTypeHandler() {
      const vm = this;

      this.$store.dispatch('get', {url: "/irdomesticinquirydetail/" + this.id})
        .then((res) => {
          if (res.data.rec.length == 0) {
            vm.loading = false;
            return false
          }
          vm.formData.panelmemberdetail = res.data.rec;
         
          for (let i = 0; i < vm.formData.panelmemberdetail.length; i++) {
            vm.formData.panelmemberdetail[i].panelmembername = vm.formData.panelmemberdetail[i].psnname
            
            Object.assign(vm.formData.panelmemberdetail[i], {
              action: 2,
            });
          }

          vm.loading = false;
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },


    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/irdomesticinquiry/" + vm.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "domesticinquirylist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "domesticinquirylist" });
    },

    deleteHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }

         this.$store.dispatch('delete', {url:
            "/irdomesticinquiry/" +
            this.id +
            "/" +
            this.formData.userid})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "domesticinquirylist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    createHandler() {
      this.$router.push({ name: "domesticinquirynew" });
    },
  },

  async mounted() {
    await this.loadDomesticInquiryHandler();
  },
};
</script>